import React, { useState, useEffect } from "react";
import { useMediaQuery } from "@mui/material";

import MainMenu from "../components/MainMenu.js";
import NoticePopup from "../components/NoticePopup.js";
import ChoixGroup from '../components/ChoixGroup.js';

import { useLanguage } from "../context/LanguageContext.js";
import { useGroupe } from "../context/GroupeContext.js";

import { logDev } from "../utils/logger.js"; 

// 🔹 Page d’accueil de l’application
// - Affiche un message d’introduction ("ConnectOrCreate")
// - Montre une popup de notice au premier affichage
// - Permet la connexion à un groupe via <ConnexionGroup />
// - Affiche un logo géant temporaire avec effet de fondu
// - Intègre le menu principal en bas de page

const Accueil = ({ 
  headerHeight = 0, 
  onHeightChange, 
  onNoticeClick, 
  isAdmin, 
  contactsCount 
}) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const { setGroupe, nomGroupe } = useGroupe();
  const { t } = useLanguage();
  const [emailCreateur, setEmailCreateur] = useState("");
  const [telCreateur, setTelCreateur] = useState("");
  const [motdepasseAdmin, setMotdepasseAdmin] = useState("");
  const [motdepasseUtilisateur, setMotdepasseUtilisateur] = useState("");

  // ✅ États locaux
  const [showNotice, setShowNotice] = useState(true); // ✅ affichée par défaut
  const [showBigLogo, setShowBigLogo] = useState(false); // ✅ logo géant
  const [fadeOut, setFadeOut] = useState(false); // ✅ contrôle du fondu

  // 🔄 Quand la notice est fermée → afficher le logo géant avec effet de fondu
  useEffect(() => {
    if (!showNotice) {
      setShowBigLogo(true);

      // lancer le fondu après un petit délai
      const timer = setTimeout(() => setFadeOut(true), 100); 

      // cacher complètement après l’animation
      const removeTimer = setTimeout(() => setShowBigLogo(false), 3100); 

      // nettoyage des timers si le composant est démonté
      return () => {
        clearTimeout(timer);
        clearTimeout(removeTimer);
      };
    }
  }, [showNotice]);

  return (
    <div style={{ textAlign: "center", padding: "2rem", paddingTop: headerHeight, background: "transparent" }}>

      {/* ✅ Popup de notice affichée au chargement */}
      {showNotice && <NoticePopup onClose={() => setShowNotice(false)} headerHeight={headerHeight} />}

      {/* ✅ Zone de connexion à un groupe */}  
      <div 
      className="connexion-container"
      style={{ backgroundColor:"#f4ece2",

       }}
      >
        <ChoixGroup 
          headerHeight={headerHeight}
          onGroupeValide={(groupe) => {
            setGroupe(groupe._id, groupe.role); // ✅ met à jour contexte + storage
            logDev("[Accueil] Groupe validé", { groupeId: groupe._id, role: groupe.role, nom: groupe.nom });
          }}
          // 👉 on transmet les états
          emailCreateur={emailCreateur}
          setEmailCreateur={setEmailCreateur}
          telCreateur={telCreateur}
          setTelCreateur={setTelCreateur}
          motdepasseAdmin={motdepasseAdmin}
          setMotdepasseAdmin={setMotdepasseAdmin}
          motdepasseUtilisateur={motdepasseUtilisateur}
          setMotdepasseUtilisateur={setMotdepasseUtilisateur}
          />
      </div>

      {/* ✅ Logo géant qui apparaît puis disparaît en fondu */}
      {showBigLogo && (
        <img
          src="/OrgZ-GD3.png"
          alt="Logo géant"
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: fadeOut 
              ? "translate(-50%, -50%) scale(1)" 
              : "translate(-50%, -50%) scale(1.15)",
            width: isMobile ? "95vw" : "60vw",
            maxWidth: isMobile ? "420px" : "650px",
            opacity: fadeOut ? 0 : 1,
            transition: "opacity 3s ease-out, transform 3s ease-out",
            zIndex: 2000,
            pointerEvents: "none"
          }}
        />
      )}

      {/* ✅ Menu principal en bas de page */}
      <MainMenu
        isMobile={isMobile}
        headerHeight={headerHeight}
        onHeightChange={onHeightChange}
        onNoticeClick={() => setShowNotice(true)}
        isAdmin={isAdmin}
        contactsCount={contactsCount}
      />
      
    </div>
  );
};

export default Accueil;
